import React from "react";

export function Btn({ variant = "primary", className = "", children, ...rest }) {
    const base =
        "w-full font-sans font-bold tracking-[0.16em] uppercase text-xs py-4 px-6 transition-colors flex justify-center items-center";
    const variants = {
        primary: "bg-burgundy text-cream hover:bg-burgundy-deep",
        secondary: "bg-transparent border border-burgundy text-burgundy hover:bg-cream-soft",
        ghost: "text-burgundy underline-offset-4 hover:underline tracking-widest",
        gold: "bg-gold text-burgundy hover:bg-gold-deep",
    };
    return (
        <button
            className={`${base} ${variants[variant]} ${className}`}
            {...rest}
        >
            {children}
        </button>
    );
}

export function Eyebrow({ children, className = "" }) {
    return (
        <span
            className={`inline-block text-[10px] tracking-[0.3em] uppercase text-burgundy/80 font-sans font-semibold ${className}`}
        >
            {children}
        </span>
    );
}

export function Rule({ className = "" }) {
    return <div className={`editorial-rule ${className}`} />;
}
